import React, { useEffect, useState } from "react";
import {
  getAllEmployees,
  createEmployee,
  updateEmployee,
  deleteEmployee,
} from "../services/AdminService";
import AdminNavbar from "../components/AdminNavbar"; // ✅ already imported
import { getToken } from "../services/user-service";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const AdminEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
  });

  const token = getToken();

  const loadEmployees = async () => {
    try {
      const data = await getAllEmployees(token);
      setEmployees(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadEmployees();
  }, []);

 const handleOpenDialog = (employee = null) => {
  if (employee) {
    setEditingEmployee({
      ...employee,
      id: employee.employeeId, // 🔥 Ensures the correct ID is used
    });
    setFormData({
      username: employee.username || "", 
      firstName: employee.firstName || "",
      lastName: employee.lastName || "",
      email: employee.email || "",
      password: "", 
    });
  } else {
    setEditingEmployee(null);
    setFormData({
      username: "",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    });
  }
  setOpen(true);
};

const handleClose = () => {
    setOpen(false);
    setEditingEmployee(null);
  };

const handleSubmit = async () => {
  try {
    // Only validate password on create
    if (!editingEmployee && !formData.password.trim()) {
      alert("Password is required");
      return;
    }

    if (editingEmployee) {
      await updateEmployee(editingEmployee.id, formData, token);
    } else {
      await createEmployee(formData, token);
    }

    handleClose();
    loadEmployees();
  } catch (err) {
    console.error(err);
  }
};


  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      await deleteEmployee(id, token);
      loadEmployees();
    }
  };

  return (
    <>
      <AdminNavbar /> 

      <Box p={3} mt={10}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4">Employees</Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenDialog()}>
            Add Employee
          </Button>
        </Box>

        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>username</TableCell>
                <TableCell>Ticket Count</TableCell>
                <TableCell>Tickets</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {employees.map((emp, index) => (
                <TableRow key={emp.employeeId}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{emp.username}</TableCell>
                  <TableCell>{emp.ticketCount}</TableCell>
                  <TableCell>
                    {emp.tickets.map(ticket => (
                      <div key={ticket.ticketId}>
                        <strong>ID:</strong> {ticket.ticketId}<br />
                        <strong>Subject:</strong> {ticket.subject}<br />
                        <strong>Status:</strong> {ticket.status}<br />
                        <hr />
                      </div>
                    ))}
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleOpenDialog(emp)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(emp.employeeId)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{editingEmployee ? "Edit Employee" : "Add Employee"}</DialogTitle>
          <DialogContent>
            <TextField
              label="First Name"
              fullWidth
              margin="dense"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
            />
            <TextField
              label="Last Name"
              fullWidth
              margin="dense"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
            />
            <TextField
              label="Email"
              fullWidth
              margin="dense"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
            <TextField
              label="Username"
              fullWidth
              margin="dense"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
            />
            {!editingEmployee && (
              <TextField
                label="Password"
                type="password"
                fullWidth
                margin="dense"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              {editingEmployee ? "Update" : "Create"}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default AdminEmployees;
